import { IndicatorData } from '../TechnicalAnalysisTradingView';
import { OhlcRow } from './SMA';

// Shio based on 60-day Ganzhi cycle (12 zodiac animals x 5 = 60)



// Shio to number mapping
const shioToNumber: Record<string, number> = {
  "Rat": 11, "Ox": 0, "Tiger": 1, "Rabbit": 2,
  "Dragon": 3, "Snake": 4, "Horse": 5, "Goat": 6,
  "Monkey": 7, "Rooster": 8, "Dog": 9, "Pig": 10
};

// Shio color mapping
const shioColors: Record<string, string> = {
  "Rat": "#1E40AF",      // Blue
  "Ox": "#166534",       // Green
  "Tiger": "#059669",    // Emerald
  "Rabbit": "#65A30D",   // Lime
  "Dragon": "#DC2626",   // Red
  "Snake": "#EA580C",    // Orange
  "Horse": "#D97706",    // Amber
  "Goat": "#FBBF24",     // Yellow
  "Monkey": "#92400E",   // Brown
  "Rooster": "#F59E0B",  // Orange
  "Dog": "#7C2D12",      // Dark Brown
  "Pig": "#7C3AED"       // Purple
};

// Get shio emoji
const getShioEmoji = (shio: string): string => {
  const emojiMap: Record<string, string> = {
    "Rat": "🐭", "Ox": "🐂", "Tiger": "🐅", "Rabbit": "🐇",
    "Dragon": "🐲", "Snake": "🐍", "Horse": "🐴", "Goat": "🐐",
    "Monkey": "🐒", "Rooster": "🐓", "Dog": "🐕", "Pig": "🐷"
  };
  return emojiMap[shio] || "⭐";
};

import { getDayBaZiDetail } from './BaZiIndicator';

// Export function to get daily shio info
export function getDailyShioInfo(date: Date, timeframe?: string): { shio: string; color: string; emoji: string; yinyang: "Yin" | "Yang"; yyCode: "A" | "I" } {
  const bazi = getDayBaZiDetail(date, timeframe);
  const shio = bazi.shio;
  return {
    shio,
    color: shioColors[shio] || "#6B7280",
    emoji: getShioEmoji(shio),
    yinyang: bazi.shioYinYang,
    yyCode: bazi.shioYYCode,
  };
}

// Export shio info for legend
export const SHIO_INFO = Object.keys(shioColors).map(shio => ({
  name: shio,
  emoji: getShioEmoji(shio),
  color: shioColors[shio]
}));

// Use BaZiCycleAnalysis method exactly (copied from BaZiCycleAnalysis.tsx line 273-281)
function dayPillarExact(localDate: Date, timeframe?: string){
  const bazi = getDayBaZiDetail(localDate, timeframe);
  return { 
    pillarCN: bazi.pillarCN, 
    stemCN: bazi.stemCN, 
    branchCN: bazi.branchCN, 
    element: bazi.mainElement, 
    yinyang: bazi.mainYinYang, 
    shio: bazi.shio 
  };
}

export function calculateDailyShio(data: OhlcRow[], timeframe?: string): { 
  data: IndicatorData[]; 
  labels: string[];
  colors: string[];
} {
  const result: IndicatorData[] = [];
  const labels: string[] = [];
  const colors: string[] = [];
  
  let lastDate = '';
  
  for (const row of data) {
    const date = new Date(row.time * 1000);
    
    // Get date string in YYYY-MM-DD format to check if it's a new day
    const dateStr = date.toISOString().split('T')[0] || '';
    const isNewDay = dateStr !== lastDate;
    
    if (isNewDay) {
      const pillarData = dayPillarExact(date, timeframe);
      const shio = pillarData.shio;
      const shioNum = shioToNumber[shio] || 0;
      
      result.push({
        time: row.time,
        value: shioNum
      });
      
      labels.push(shio);
      colors.push(shioColors[shio] || "#6B7280");
      
      lastDate = dateStr;
    } else {
      // For same day, use the last calculated value
      result.push({
        time: row.time,
        value: result[result.length - 1]?.value || 11
      });
      
      labels.push(labels[labels.length - 1] || "Rat");
      colors.push(colors[colors.length - 1] || "#6B7280");
    }
  }
  
  return { data: result, labels, colors };
}
